import de from '@translations/de/changeProfileEmailPopup.json';
import en from '@translations/en/changeProfileEmailPopup.json';
import pl from '@translations/pl/changeProfileEmailPopup.json';
import sl from '@translations/sl/changeProfileEmailPopup.json';
import uk from '@translations/uk/changeProfileEmailPopup.json';
import bg from '@translations/bg/changeProfileEmailPopup.json';
import cz from '@translations/cz/changeProfileEmailPopup.json';
import fr from '@translations/fr/changeProfileEmailPopup.json';
import gr from '@translations/gr/changeProfileEmailPopup.json';
import it from '@translations/it/changeProfileEmailPopup.json';
import pr from '@translations/pr/changeProfileEmailPopup.json';
import ru from '@translations/ru/changeProfileEmailPopup.json';
import sk from '@translations/sk/changeProfileEmailPopup.json';
import sp from '@translations/sp/changeProfileEmailPopup.json';
import tr from '@translations/tr/changeProfileEmailPopup.json';
import hu from '@translations/hu/changeProfileEmailPopup.json';
import { ITranslations } from '@/types/common';
import { ChangeProfileEmailPopupTransFields } from './types';

export const changeProfileEmailPopupTranslations: ITranslations<ChangeProfileEmailPopupTransFields> =
  {
    name: 'changeProfileEmailPopup',
    de,
    en,
    pl,
    sl,
    uk,
    bg,
    cz,
    fr,
    gr,
    it,
    pr,
    ru,
    sk,
    sp,
    tr,
    hu,
  };
